"use strict";
// <copyright file="common-helper.ts" company="Top365">
// Copyright (c) Microsoft. All rights reserved.
// </copyright>
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelper = void 0;
var CommonHelper = /** @class */ (function () {
    function CommonHelper() {
    }
    CommonHelper.validUrl = function (url) {
        try {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?', 'i'); // query string
            return !!pattern.test(url);
        }
        catch (e) {
            console.log(e);
            return false;
        }
    };
    CommonHelper.checkIfContainHttps = function (url) {
        if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
            url = "https://" + url;
        }
        return url;
    };
    return CommonHelper;
}());
exports.CommonHelper = CommonHelper;
//# sourceMappingURL=common-helper.js.map